import React from 'react';
import Grid from '@mui/material/Grid';
import { ChartOptions, ChartData } from 'chart.js';
import GenericChart from 'src/components-dummy/Chart/Chart';
import { ChartType } from '../../types';
import { Box, Tooltip, Typography } from '@mui/material';

export interface PieChartProps {
  data: ChartData<'doughnut'>;
  options?: ChartOptions<'doughnut'>;
}

export default function PieChart({ data, options }: PieChartProps): JSX.Element {
  const total = data.datasets[0].data.reduce((sum, v) => sum + Number(v), 0);
  const legendItems = data.labels.map((label, i) => {
    const value = Number(data.datasets[0].data[i]);
    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
    const bgColor = (data.datasets[0].backgroundColor as string[])[i];
    return { label: String(label), percentage, color: bgColor };
  });

  return (
    <Box display='flex' justifyContent='center' width='100%' flexDirection='row'>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <GenericChart
          type={ChartType.Doughnut}
          data={data}
          options={options}
          width='270px'
          height='270px'
        />

        <Box mt={2} sx={{ width: '100%', maxWidth: 220, mt: 4 }}>
          {legendItems.map(item => (
            <Grid
              container
              key={item.label}
              alignItems='center'
              justifyContent='space-between'
              sx={{ mb: 1 }}
            >
              <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                <Box
                  sx={{
                    width: 7,
                    height: 7,
                    backgroundColor: item.color,
                    mr: 1,
                  }}
                />
                <Tooltip title={item.label} placement='top'>
                  <Typography
                    sx={{
                      color: '#000',
                      maxWidth: 160,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      cursor: 'default',
                    }}
                  >
                    {item.label}
                  </Typography>
                </Tooltip>
              </Grid>

              <Grid item xs={4}>
                <Typography sx={{ color: item.color, textAlign: 'right', fontWeight: 500 }}>
                  {item.percentage}%
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
